import { EmspUserInvoiceBaseModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/invoices-service-lib/src/wrapper/outputs/emsp-user-invoice-base.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { EmspBoInvoiceListEmspUserFirstNameCell } from './emsp-bo-invoice-list-emsp-user-first-name.cell';
import { EmspBoInvoiceListEmspUserFirstNameHeader } from './emsp-bo-invoice-list-emsp-user-first-name.header';

export const EmspBoInvoiceListEmspUserFirstNameColumn: IdentifiedColumnDef<
  EmspUserInvoiceBaseModel,
  EmspUserInvoiceBaseModel['emspUser']['firstName']
> = {
  id: 'emspUserFirstName',
  enableSorting: false,
  header: EmspBoInvoiceListEmspUserFirstNameHeader,
  cell: EmspBoInvoiceListEmspUserFirstNameCell,
};
